goog.provide('el8.ptdata.letterReceipts');

goog.require('el8.app.shared.dialog.fileReportsPrompt');
goog.require('el8.appservice.notifier');
goog.require('el8.model.base');
goog.require('el8.ptdata.comments');
goog.require('el8.ptdata.model.letterAttachment');
goog.require('el8.service.urls');

el8.ptdata.letterReceipts = (function() {

    var _class = function(spec) {
        this.populate(spec);
    };
    _class.inheritsFrom(el8_Entity);
    _class.makeDocument();

    _class.addIntProperty('toUserId');
    _class.addStringProperty('senderName');
    _class.addStringProperty('receiverName');
    _class.addDateTime('sentTime');
    _class.addDate('sentDate');

    _class.addStringProperty('subject');
    _class.addStringProperty('body');

    _class.addIntProperty('filedAsDocumentId', false);
    _class.addProperty('commentIds', false, []);
    _class.addModelSetProperty('attachments', el8.ptdata.model.letterAttachment, false, []);

    // used to track the expanded state of the chart render item, for feed item refresh
    _class.addBoolean('chartItemExpanded', false);
    _class.addBoolean('referralLetter');

    _class.addStringProperty('authorizationFor', true);
    _class.addStringProperty('authNumber', true);
    _class.addIcd9s();
    _class.addIcd10s();

    _class.addBoolean('withArchive', false); // do we have a ZIP in addition to a single, big PDF?

    _class.addBoolean('withPlrInvite', false); // was this letter sent w/ an intention to invite someone to join care team?

    _class.addBoolean('ptLetter', false);

    _class.addIntProperty('closeUserId');
    _class.addDateTime('closeTime');

    _class.addStringProperty('inProgressComment', false);

    _class.prototype.populate = function(spec) {
        this.parent.populate.call(this, spec);

        // load these comments into the comment cache and store just the ids in the letter
        if (spec.comments) {
            el8.ptdata.comments.create(spec.comments, true);
            this.setCommentIds(_.pluck(spec.comments, 'id'));
        }
    };

    _class.prototype.getNoteSummary = function() {
        return el8.template.ptdata.letterReceipts.noteSummary(this.asSoyMap()).el8_unescape();
    };
    _class.prototype.getDescription = function() {
        return 'Received Letter';
    };

    _class.prototype.asSoyMap = function() {
        var mapped = this.parent.asSoyMap.call(this);

        delete mapped['commentIds'];
        mapped['comments'] = this.getComments().map(el8.model.toSoyMapFn);

        mapped['attachments'] = this.getAttachments().map(el8.model.toSoyMapFn);

        delete mapped['signUserId'];
        mapped['signUserName'] = this.getSignUserName();
        mapped['signUserType'] = this.getSignUserType();
        mapped['icd9CodeObjs'] = this.getIcd9CodeObjs().map(el8.model.toSoyMapFn);
        mapped['icd10CodeObjs'] = this.getIcd10CodeObjs().map(el8.model.toSoyMapFn);

        delete mapped['closeUserId'];
        mapped['closeUserName'] = this.getCloseUserId() ?
            el8.data.referencedUsers.getById(this.getCloseUserId()).getFullName() : '';
        mapped['canReopenThread'] = this.getCloseUserId() ?
            (this.getCloseUserId() === el8.data.currUser.getId()) : false;

        return mapped;
    };

    _class.prototype.getComments = function() {
        return this.getCommentIds().map(function(id) {
            return el8.ptdata.comments.getById(id);
        });
    };

    var that = new el8_EntitySet({
        model: function(spec) {
            return new _class(spec);
        },
        deleteFn: function(var_args) { return el8.ptdata.documentDeleteFn.apply(that, arguments); }
    });

    _class.prototype.addComment = function(opts) {
        opts = opts || {};
        var submissionDict = {};

        if (opts.message) {
            submissionDict['new_comment'] = opts.message;
        }
        if (this.getCommentIds().length) {
            submissionDict['comments_signed_off'] = this.getCommentIds();
        }
        if (opts.closeThread === true) {
            submissionDict['close_thread'] = true;
        }
        if (opts.reopenThread === true) {
            submissionDict['reopen_thread'] = true;
        }

        var ajaxArgs = {
            type: 'POST',
            async: (opts.async !== false), // default true
            data: JSON.stringify(submissionDict),
            url: el8.service.urls.get('addLetterReceiptComment', [this]),
            success: function(data) {
                var updated = that.create(data);
                if (opts.successCb) { opts.successCb(updated); }
            }
        };
        // want to support either error (default) or error_override (for dealing with closed threads)
        if (opts.errorOverrideCb) {
            ajaxArgs.error_override = opts.errorOverrideCb;
        } else {
            ajaxArgs.error = opts.errorCb;
        }
        $.el8_ajax(ajaxArgs);
    };
    _class.prototype.dismissComments = function(successCb, errorCb) {
        // without a message, addComment just dismisses existing comments
        this.addComment({successCb: successCb, errorCb: errorCb});
    };

    _class.prototype.reopenThread = function(successCb, errorCb) {
        // this is like dismissComments but we also close the thread
        this.addComment({
            reopenThread: true,
            successCb: successCb,
            errorCb: errorCb
        });
    };
    _class.prototype.sign = function(opts) {
        opts = opts || {};
        var data = { file_as_consultation_report: Boolean(opts.fileConsult) };

        var thisReceipt = this; // 'that' refers to el8.ptdata.letterReceipts
        var postSign = function() {
            $.el8_ajax({
                type: 'POST',
                async: (opts.async !== false), // default true
                url: el8.service.urls.get('signLetterReceipt', [thisReceipt]),
                data: JSON.stringify(data),
                success: function(data) {
                    var updated = that.create(data.letter_receipt);
                    if (data.report) {
                        el8.ptdata.reports.create(data.report);
                    }

                    if (opts.successCb) { opts.successCb(updated); }

                    if (thisReceipt.getNewCommentCount()) {
                        thisReceipt.dismissComments();
                    }
                },
                error_override: function(data) {
                    if (data.status === 409) {
                        el8.uiwidget.alert('This letter was already signed off in another window.');
                    } else {
                        el8.uiwidget.alert(el8.util.consts.DEFAULT_ERROR_MSG);
                    }
                    if (opts.errorCb) { opts.errorCb(); }
                }
            });
        };

        if (opts.$receiptElem) {
            // this can take a while, especially if we file reports - make sure the user
            // knows we're working and disable double clicks
            opts.$receiptElem.find('.sign-letter-receipt').prop('disabled', true);
            opts.$receiptElem.find('.reassign-receipt-trigger').prop('disabled', true);
            opts.$receiptElem.find('.filing-status').addClass('el8ShortLoading');
        }

        var fileables = [];
        var unfileables = [];
        this.getAttachments().forEach(function(a) {
            var type = a.getAttachmentType();
            var map = a.asSoyMap();
            if (type === 'Report' || type === 'VisitNote' || type === 'NonvisitNote' || type === 'ReferralOrder' || type === 'MessageThread') {
                fileables.push(map);
            } else {
                unfileables.push(map);
            }
        });
        /** We want to file reports before signing the letter receipt
         * But for passport_emr accounts, we've already filed everything, so skip that step
         */
        if (!el8Globals.PASSPORT_EMR && fileables.length) { // only show the dialog if there are fileable attachments
            el8.app.shared.dialog.fileReportsPrompt.show({
                fileableAttachments: fileables,
                unfileableAttachments: unfileables,
                patientId: this.getPatientId(),
                yesFn: function(ids) { thisReceipt.fileReports(ids, postSign); },
                noFn: function() { postSign(); }
            });
        } else {
            postSign();
        }
    };

    _class.prototype.fileReports = function(attachmentIds, successCb) {
        var thisReceipt = this;

        el8.appservice.notifier.notify('Filing letter attachments...');
        $.el8_longPoll({
            url: el8.service.urls.get('fileReceiptAttachments', [thisReceipt]),
            data: JSON.stringify({attachment_ids: attachmentIds}),
            success: function(data) {
                var updated = that.create(data.receipt);
                that.trigger(EVENTS.FILED, updated);
                el8.appservice.notifier.notify('Reports successfully filed into patient\'s chart');
                if (successCb) { successCb(updated); }
            }
        });
    };
    _class.prototype.fileReport = function(attachmentId, successCb) {
        this.fileReports([attachmentId], successCb);
    };
    _class.prototype.markReportUnfiled = function(reportId) {
        if (this.getFiledAsDocumentId() === reportId) {
            // this report was the LetterContents consult report
            this.setFiledAsDocumentId(null);
            return;
        }
        // otherwise, search the attachments for this report
        var match = _.find(this.getAttachments(), function(a) { return a.getEntityId() === reportId; });
        if (match) { match.setEntityId(null); }
    };

    _class.prototype.getNewCommentCount = function() {
        // the 'byPatient' param is always false for letterReceipts
        var commentIsUnread = function(c) { return !c.isRead(); };
        return _.filter(this.getComments(), commentIsUnread).length;
    };

    return that;

})();
